export default "__VITE_ASSET__hG7aeltD__"